<template lang="html">
	<div class="manager-track-report center-panel report">
		<md-content md-theme="white" v-loader-overlay="progress">
			<sort-table
				v-bind:columns="tableColumns" v-model="deals" v-on:refresh="getDeals" v-bind:per-page="perPage" 
				v-bind:total="dealsAmount" table-id="report" default-order="desc" default-sort="id"
				v-bind:showAddButton="false" v-bind:link="false"
			>
				<template slot="first_freight" slot-scope="scope">
					<span class="no-break-text"> {{(scope.item.first_freight && scope.item.first_freight.traking_number) ? scope.item.first_freight.traking_number : 'Не установлен'}} </span>
				</template>

				<template slot="created_at" slot-scope="scope">
					<span class="no-break-text"> {{(scope.item.created_at && scope.item.created_at) ? moment(scope.item.created_at).format('DD MMM YYYY') : 'Не установлен'}} </span>
				</template>

				<template slot="from_stock" slot-scope="scope">
					<span v-if="scope.item.from_address && scope.item.from_address.address"> {{scope.item.from_address.address}} </span>
					<span class="no-break-text" v-if="scope.item.from_stock && scope.item.from_stock.name"> {{scope.item.from_stock.name}} </span>
					<span class="no-break-text" v-if="!scope.item.from_address && !scope.item.from_stock"> Не указан </span>
				</template>

				<template slot="to_stock" slot-scope="scope">
					<span v-if="scope.item.to_address && scope.item.to_address.address"> {{scope.item.to_address.address}} </span>
					<span class="no-break-text" v-if="scope.item.to_stock && scope.item.to_stock.name"> {{scope.item.to_stock.name}} </span>
					<span class="no-break-text" v-if="!scope.item.to_address && !scope.item.to_stock"> Не указан </span>
				</template>

				<template slot="documents" slot-scope="scope">
					<div v-if="scope.item.documents && scope.item.documents.length">
						<div v-for="doc in scope.item.documents">
							<div v-if="doc.type && docs[doc.type]" class="no-break-text"> {{docs[doc.type]}} </div>
						</div>
					</div>
					<div v-if="!scope.item.documents || !scope.item.documents.length"> Документы не созданны </div>
				</template>

				<template slot="payer" slot-scope="scope">
					<span v-if="scope.item.payer && scope.item.payer.name"> {{scope.item.payer.name}} </span>
					<span v-else> Не указан </span>
				</template>

				<template slot="seats" slot-scope="scope">
					<span class="no-break-text" v-if="scope.item.first_freight && scope.item.first_freight.seats_number"> {{scope.item.first_freight.seats_number}} </span>
					<span class="no-break-text" v-else> Не указано </span>
				</template>

				<template slot="weight" slot-scope="scope">
					<span class="no-break-text" v-if="scope.item.first_freight && scope.item.first_freight.weight"> {{scope.item.first_freight.weight + ' кг'}} </span>
					<span class="no-break-text" v-else> Не указан </span>
				</template>

				<template slot="size" slot-scope="scope">
					<span class="no-break-text" v-if="scope.item.first_freight && scope.item.first_freight.size"> {{scope.item.first_freight.size + ' ' + ((scope.item.first_freight.size_units) ? scope.item.first_freight.size_units : 'м') }} </span>
					<span class="no-break-text" v-else> Не указан </span>
				</template>

				<template slot="price" slot-scope="scope">
					<span class="no-break-text" v-if="scope.item.price && parseInt(scope.item.price) != 0"> {{scope.item.price + ' руб.'}} </span>
					<span class="no-break-text" v-else> Не указанна </span>
				</template>
			</sort-table>
		</md-content>
	</div>
</template>
<script>
	import SortTable from "@/components/SortTable"
	import reportsMenu from './reports-menu';
	export default {
		components: {SortTable, reportsMenu},
		data() {
			return {
				tableColumns: [
					{label: 'ID',             field: 'id',            sortable: true },
					{label: 'Треккод',        field: 'first_freight', sortable: true },
					{label: 'Дата создания',  field: 'created_at',    sortable: true },
					{label: 'П. отпр',        field: 'from_stock',    sortable: false},
					{label: 'П. назн',        field: 'to_stock',      sortable: false},
					{label: 'Документы',      field: 'documents',     sortable: false},
					{label: 'Плательщик',     field: 'payer',         sortable: false },
					{label: 'Кол-во мест',    field: 'seats',         sortable: false },
					{label: 'Вес',            field: 'weight',        sortable: false },
					{label: 'Объем',          field: 'size',          sortable: false },
					{label: 'Основная сумма', field: 'price',         sortable: true },
					{label: '', 			  field: 'actions',       sortable: true }
					
					/**
					{ label: 'Авто в п. отпр', field: 'traking_number', sortable: true },
					{ label: 'Авто в п. назн', field: 'traking_number', sortable: true },
					{ label: 'Общая сумма',    field: 'traking_number', sortable: true },
					{ label: 'Признак оплаты', field: 'traking_number', sortable: true },
					{ label: 'Прочее',         field: 'traking_number', sortable: true },
					*/
				],
				currentPage: 1,
				perPage: 50,
				filter: null,
				docs: {
					bill: 'Счёт',
					invoice: 'Счёт фактура',
					assignment: 'Поручение экспедитору',
					recepit: 'Экспедиторская расписка',
					act: 'Акт выполненных работ',
					stock_note: 'Складская записка',
					route_list: 'Маршрутный лист'
				}
			}
		},
		created() {
			this.$store.dispatch('deals/getStatuses');
			this.$store.commit('setTitle', 'Путевой отчет менеджера');
		},
		watch: {
			'$route.query.filter'(filter) {
				if (filter) this.filter = Object.assign({}, JSON.parse(filter));
				else this.filter = null;
				this.getDeals(this.currentPage, this.perPage, 'id', 'desc');
			}
		},
		computed: {
			/**
			 * Флаг загрузки текущего компонента
			 */
			progress() {
				return this.progressObj['get-deals-list'];
			},
			/**
			 * Объект флагов загрузки
			 */
			progressObj() {
				return this.$store.state.progressObj;
			},
			/**
			 * Список заявок
			 */
			deals() {
				return this.$store.state.deals.deals
			},
			/**
			 * Количество заявок
			 */
			dealsAmount() {
				return this.$store.state.deals.deals_amount
			},
		},
		methods: {
			/**
			 * Получение заявок
			 */
			getDeals(page, count, orderBy, orderType) {
				this.$store.commit('showProgressBar', 'get-deals-list');
				let data = {
					page:       (page)      ? page      : 1, 
					order_by:   (orderBy)   ? orderBy   : 'id', 
					order_type: (orderType) ? orderType : 'desc',
					count:      (count)     ? count     : 50,
					filter:     (this.filter) ? this.filter : null 
				};
				return this.$store.dispatch('deals/getDeals', data)
					.finally(() => this.$store.commit('hideProgressBar', 'get-deals-list'));
			},
		}
	}
</script>


// WEBPACK FOOTER //
// ManagerTrackReport.vue?4af86620